/**
 * Единое форматирование российского мобильного номера для полей ввода.
 * Маска: +7 (XXX) XXX-XX-XX
 * Ввод с 8 → нормализуется к +7; 10 цифр, начинающихся с 9 → добавляется 7.
 */

function digitsOnly(s) {
  return String(s ?? "").replace(/\D/g, "");
}

/** Цифры после «кода страны» 7, максимум 10 штук */
function normalizeLeadingDigits(d) {
  let x = digitsOnly(d);
  if (x.startsWith("8")) x = "7" + x.slice(1);
  if (!x.startsWith("7") && x.length > 0 && x[0] === "9") {
    x = "7" + x;
  }
  return x.slice(0, 11);
}

/**
 * Значение для controlled input (с пробелами и скобками).
 */
export function formatRuPhoneInput(raw) {
  const d = normalizeLeadingDigits(raw);
  if (!d.length) return "";

  if (!d.startsWith("7")) {
    return String(raw).slice(0, 24);
  }

  const rest = d.slice(1);
  let out = "+7";

  if (!rest.length) return out;

  out += " (";
  out += rest.slice(0, Math.min(3, rest.length));

  if (rest.length <= 3) {
    return rest.length === 3 ? `${out}) ` : out;
  }

  out += ") ";
  out += rest.slice(3, Math.min(6, rest.length));

  if (rest.length <= 6) return out;

  out += "-";
  out += rest.slice(6, Math.min(8, rest.length));

  if (rest.length <= 8) return out;

  out += "-";
  out += rest.slice(8, 10);
  return out;
}

/**
 * Номер для API и localStorage: +7XXXXXXXXXX при полном мобильном, иначе только цифры с + где уместно.
 */
export function normalizeRuPhoneE164(formattedOrRaw) {
  const d = normalizeLeadingDigits(formattedOrRaw);
  if (d.length === 11 && d.startsWith("7")) {
    return `+${d}`;
  }
  if (d.length > 0) return `+${d}`;
  return "";
}

/** Полный российский мобильный: 11 цифр, начинается с 7, вторая цифра часто 9 */
export function isRuMobileComplete(formattedOrRaw) {
  const d = normalizeLeadingDigits(formattedOrRaw);
  return d.length === 11 && d.startsWith("7");
}
